export const colors = {
  common: {
    black: '#000000',
    white: '#ffffff',
  },
  error: {
    light: '#e57373',
    main: '#f44336',
    dark: '#d32f2f',
  },
  warning: {
    light: '#ffb74d',
    main: '#ff9800',
    dark: '#ca4000',
  },
  info: {
    light: '#64b5f6',
    main: '#2196f3',
    dark: '#1976d2',
  },
  success: {
    light: '#81c784',
    main: '#4caf50',
    dark: '#388e3c',
  },
  appBackground: {
    light: '#f0f0f0',
    main: '#f1f1f1',
    dark: '#f3f3f3',
  },
}

export const app = {
  drawer: {
    mainNavigationWidth: 68,
    mainNavigationWidthOpen: 240,
    mobileMaxWidth: '75vw',
  },
  scaleFactor: {
    default: '1vw + 0.5rem',
    large: '2.5vw + 0.5rem',
  },
  input: {
    borderRadius: '0.25rem',
    focus: {
      boxShadow: `
        0 0 0 1px rgba(100, 181, 246, 0.85),
        0 0 0 4px rgba(100, 181, 246, 0.25)
      `,
    },
  },
  button: {
    borderRadius: '0.25rem',
  },
  widget: { borderRadius: '0.25rem' },
}

export const components = {
  appBar: {
    borderRadius: app.widget.borderRadius,
    backgroundColor: colors.common.white,
  },
  mainNavigationDrawer: {
    borderRadius: app.widget.borderRadius,
    backgroundColor: colors.common.white,
    open: {
      backgroundColor: colors.common.white,
    },
  },
  ListMainNavigation: {
    color: colors.common.black,
    hover: {
      color: colors.common.black,
      backgroundColor: colors.common.white,
    },
    selected: {
      color: colors.common.black,
      backgroundColor: colors.common.white,
    },
  },
}
